import { inject, Injectable } from '@angular/core';
import {
  selectAllEntities,
  selectEntity,
  setEntities,
} from '@ngneat/elf-entities';
import { ResourceStatusService } from '@thiememeulenhoff/ng-api-gateway';
import { map, tap } from 'rxjs';
import {
  ResourceStatusCollection,
  ResourceStatusResponse,
} from '@thiememeulenhoff/types';
import * as stores from './resource-status.store';
import {
  buildResourceStatusIdentifier,
  convertToResourceStatuses,
} from './resource-status.facade.util';

@Injectable({
  providedIn: 'root',
})
export class ResourceStatusFacade {
  readonly #store = stores.resourceStatus;

  readonly #service = inject(ResourceStatusService);

  readonly disabledStatus$ = (actorId: string, contentPath: string) =>
    this.#store.pipe(
      selectEntity(
        buildResourceStatusIdentifier(actorId, contentPath, 'disabled'),
      ),
    );

  readonly reviewStatus$ = (actorId: string, contentPath: string) =>
    this.#store.pipe(
      selectEntity(
        buildResourceStatusIdentifier(actorId, contentPath, 'reviewDisabled'),
      ),
    );

  readonly resourceStatusesForAction$ = (action: string) =>
    this.#store.pipe(
      selectAllEntities(),
      map((states) => states.filter((state) => state.action === action)),
    );

  readonly resourceStatusesForActor$ = (actor: string) =>
    this.#store.pipe(
      selectAllEntities(),
      map((states) => states.filter((state) => state.actor === actor)),
    );

  fetchGroupResourceStatus(
    groupCode: string,
    arrangementCode: string,
    contentIdentifier: string,
  ) {
    return this.#service
      .fetchGroupResourceStatus(groupCode, arrangementCode, contentIdentifier)
      .pipe(
        tap((states: Array<ResourceStatusResponse>) =>
          this.#handleGroupResourceStatusResponse(states),
        ),
      );
  }

  #handleGroupResourceStatusResponse(states: Array<ResourceStatusResponse>) {
    this.#store.update(setEntities(convertToResourceStatuses(states)));
  }

  storeResourceStatuses(
    arrangementCode: string,
    collection: ResourceStatusCollection,
  ) {
    return this.#service.storeResourceStatuses(arrangementCode, collection);
  }
}
